export let activityFeedTitle = "b$R3N";
export default {activityFeedTitle};